import createApiClient from './createGenericApiClient';

const client = createApiClient('payment_base');

export function getPaymentClient() {
	return client.getApolloClientInstance();
}

export default client.performRequest;
